import { useEffect, useState } from "react";
const API = "/api";
const token = () => localStorage.getItem("token");

export default function Categorias() {
  const [categorias, setCategorias] = useState<any[]>([]);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({nombre:"",descripcion:"",icono:"📦",orden:0});
  const [toast, setToast] = useState("");
  const [emojis, setEmojis] = useState<any[]>([]);
  const [mostrarEmojis, setMostrarEmojis] = useState(false);
  const [busquedaEmoji, setBusquedaEmoji] = useState("");

  const mostrarToast = (msg:string) => { setToast(msg); setTimeout(()=>setToast(""),3000); };
  const cargar = () => { fetch(API + "/categorias/").then(r=>r.json()).then(d=>Array.isArray(d)&&setCategorias(d)).catch(()=>{}); };
  useEffect(()=>{
    cargar();
    fetch(API + "/emojis/").then(r=>r.json()).then(d=>Array.isArray(d)&&setEmojis(d)).catch(()=>{});
  },[]);

  const abrirNuevo = () => { setEditando(null); setForm({nombre:"",descripcion:"",icono:"📦",orden:0}); setModal(true); setMostrarEmojis(false); };
  const abrirEditar = (c:any) => { setEditando(c); setForm({nombre:c.nombre,descripcion:c.descripcion||"",icono:c.icono||"📦",orden:c.orden||0}); setModal(true); setMostrarEmojis(false); };

  const guardar = async () => {
    const h = {"Content-Type":"application/json",Authorization:"Bearer " + token()};
    const url = editando ? API + "/categorias/" + editando.id : API + "/categorias/";
    await fetch(url,{method:editando?"PUT":"POST",headers:h,body:JSON.stringify({...form,orden:Number(form.orden)})});
    cargar(); setModal(false); mostrarToast(editando?"Categoria actualizada":"Categoria creada");
  };

  const eliminar = async (id:number) => {
    await fetch(API + "/categorias/" + id,{method:"DELETE",headers:{Authorization:"Bearer " + token()}});
    cargar(); mostrarToast("Categoria eliminada");
  };

  const emojiFiltrados = emojis.filter(e =>
    busquedaEmoji === "" || e.nombre.toLowerCase().includes(busquedaEmoji.toLowerCase()) || e.emoji.includes(busquedaEmoji)
  );

  return (
    <div>
      {toast && <div style={{position:"fixed",top:"24px",right:"24px",zIndex:50,background:"#fff",border:"1px solid #e5e7eb",boxShadow:"0 4px 20px rgba(0,0,0,0.1)",borderRadius:"12px",padding:"12px 20px",fontWeight:700,fontSize:"14px"}}>{toast}</div>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"24px"}}>
        <h1 style={{fontFamily:"Montserrat,sans-serif",fontSize:"24px",fontWeight:900,color:"#1a1a2e"}}>Categorias ({categorias.length})</h1>
        <button onClick={abrirNuevo} style={{background:"#1565C0",color:"#fff",border:"none",padding:"10px 20px",borderRadius:"12px",fontWeight:700,fontSize:"14px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>+ Agregar</button>
      </div>
      <div style={{background:"#fff",borderRadius:"16px",overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
        {categorias.length===0 ? (
          <div style={{textAlign:"center",padding:"60px",color:"#9ca3af"}}>No hay categorias</div>
        ) : categorias.map(c => (
          <div key={c.id} style={{display:"flex",alignItems:"center",gap:"16px",padding:"16px 20px",borderBottom:"1px solid #f3f4f6"}}>
            <div style={{width:"48px",height:"48px",background:"#EFF6FF",borderRadius:"12px",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"24px",flexShrink:0}}>{c.icono||"📦"}</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:800,fontSize:"15px"}}>{c.nombre}</div>
              {c.descripcion && <div style={{fontSize:"13px",color:"#6b7280"}}>{c.descripcion}</div>}
            </div>
            <div style={{display:"flex",gap:"8px"}}>
              <button onClick={()=>abrirEditar(c)} style={{background:"#EFF6FF",color:"#1565C0",border:"none",padding:"8px 16px",borderRadius:"8px",fontWeight:700,fontSize:"13px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>Editar</button>
              <button onClick={()=>eliminar(c.id)} style={{background:"#fef2f2",color:"#ef4444",border:"none",padding:"8px 12px",borderRadius:"8px",fontWeight:700,fontSize:"13px",cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>🗑</button>
            </div>
          </div>
        ))}
      </div>
      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:40,display:"flex",alignItems:"center",justifyContent:"center",padding:"24px"}}>
          <div style={{background:"#fff",borderRadius:"20px",width:"100%",maxWidth:"480px",maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{padding:"20px 24px",borderBottom:"1px solid #f3f4f6",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <h2 style={{fontFamily:"Montserrat,sans-serif",fontWeight:900,fontSize:"18px",color:"#1565C0"}}>{editando?"Editar":"Nueva"} Categoria</h2>
              <button onClick={()=>setModal(false)} style={{background:"none",border:"none",fontSize:"20px",cursor:"pointer"}}>X</button>
            </div>
            <div style={{padding:"24px",display:"flex",flexDirection:"column",gap:"16px"}}>

              <div>
                <label style={{fontSize:"12px",fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"6px"}}>Nombre</label>
                <input value={form.nombre} onChange={e=>setForm({...form,nombre:e.target.value})}
                  style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px 14px",fontSize:"14px",outline:"none",fontFamily:"Nunito,sans-serif",boxSizing:"border-box"}}/>
              </div>

              <div>
                <label style={{fontSize:"12px",fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"6px"}}>Descripcion</label>
                <input value={form.descripcion} onChange={e=>setForm({...form,descripcion:e.target.value})}
                  style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px 14px",fontSize:"14px",outline:"none",fontFamily:"Nunito,sans-serif",boxSizing:"border-box"}}/>
              </div>

              <div>
                <label style={{fontSize:"12px",fontWeight:700,color:"#6b7280",textTransform:"uppercase",letterSpacing:"1px",display:"block",marginBottom:"6px"}}>Icono</label>
                <div style={{display:"flex",gap:"10px",alignItems:"center",marginBottom:"8px"}}>
                  <div style={{width:"52px",height:"52px",background:"#EFF6FF",borderRadius:"12px",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"28px",flexShrink:0}}>{form.icono}</div>
                  <div style={{flex:1}}>
                    <input value={form.icono} onChange={e=>setForm({...form,icono:e.target.value})}
                      placeholder="Escribe o selecciona abajo"
                      style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"10px",padding:"10px 14px",fontSize:"20px",outline:"none",fontFamily:"Nunito,sans-serif",boxSizing:"border-box"}}/>
                  </div>
                </div>
                <button onClick={()=>setMostrarEmojis(!mostrarEmojis)}
                  style={{background:"#f3f4f6",border:"none",borderRadius:"10px",padding:"8px 16px",fontSize:"13px",fontWeight:700,cursor:"pointer",marginBottom:"8px"}}>
                  {mostrarEmojis ? "Ocultar banco de iconos" : "Seleccionar del banco de iconos"} 😀
                </button>
                {mostrarEmojis && (
                  <div style={{border:"2px solid #e5e7eb",borderRadius:"12px",padding:"12px"}}>
                    <input value={busquedaEmoji} onChange={e=>setBusquedaEmoji(e.target.value)}
                      placeholder="Buscar emoji..."
                      style={{width:"100%",border:"2px solid #e5e7eb",borderRadius:"8px",padding:"8px 12px",fontSize:"13px",outline:"none",marginBottom:"10px",boxSizing:"border-box",fontFamily:"Nunito,sans-serif"}}/>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(44px,1fr))",gap:"4px",maxHeight:"200px",overflowY:"auto"}}>
                      {emojiFiltrados.map(e => (
                        <button key={e.id} onClick={()=>{ setForm({...form,icono:e.emoji}); setMostrarEmojis(false); setBusquedaEmoji(""); }}
                          title={e.nombre}
                          style={{background:form.icono===e.emoji?"#DBEAFE":"#f9fafb",border:form.icono===e.emoji?"2px solid #1565C0":"2px solid transparent",borderRadius:"8px",padding:"6px",fontSize:"22px",cursor:"pointer",textAlign:"center"}}>
                          {e.emoji}
                        </button>
                      ))}
                      {emojiFiltrados.length===0 && <div style={{gridColumn:"1/-1",textAlign:"center",color:"#9ca3af",padding:"16px",fontSize:"13px"}}>No se encontraron emojis</div>}
                    </div>
                  </div>
                )}
              </div>

            </div>
            <div style={{padding:"16px 24px",borderTop:"1px solid #f3f4f6",display:"flex",gap:"12px",justifyContent:"flex-end"}}>
              <button onClick={()=>setModal(false)} style={{padding:"10px 20px",borderRadius:"10px",border:"1px solid #e5e7eb",fontSize:"14px",fontWeight:600,cursor:"pointer",background:"#fff",fontFamily:"Nunito,sans-serif"}}>Cancelar</button>
              <button onClick={guardar} style={{padding:"10px 20px",borderRadius:"10px",background:"#1565C0",color:"#fff",border:"none",fontSize:"14px",fontWeight:700,cursor:"pointer",fontFamily:"Nunito,sans-serif"}}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}